import React from "react";

const AddProject = () => {
  return (
    <>
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
     
    >
      <path
        d="M13.5 20s1 0 2 2c0 0 3.177-5 6-6"
        stroke="#044E97"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7 16h4m-4-5h8M6.504 3.5c-1.556.047-2.483.22-3.125.862-.879.88-.879 2.295-.879 5.126v6.506c0 2.832 0 4.247.879 5.127C4.257 22 5.672 22 8.5 22H11m4.496-18.5c1.556.047 2.484.22 3.125.862.879.88.879 2.295.879 5.126V13.5"
        stroke="#044E97"
        strokeWidth={1.5}
        strokeLinecap="round"
      />
      <path
        d="M6.5 3.75C6.5 2.784 7.284 2 8.25 2h5.5a1.75 1.75 0 110 3.5h-5.5A1.75 1.75 0 016.5 3.75z"
        stroke="#044E97"
        strokeWidth={1.5}
        strokeLinejoin="round"
      />
    </svg>
    </>
  );
};

export default AddProject;
